import client from './client';

export type AppealStatus = 'new' | 'accepted' | 'in_progress' | 'done' | 'rated';

export interface AppealListItem {
  id: number;
  title: string;
  status: AppealStatus;
  address?: string;
  department?: string;
  deadline?: string;
  rating?: number;
  is_anonymous: boolean;
  created_at: string;
  updated_at: string;
  thumbnail_url?: string;
  category_id?: number;
}

export interface AppealStats {
  total: number;
  by_status: Record<string, number>;
  by_category: { category_id: number; name_ru: string; count: number }[];
  by_district: { district: string; count: number }[];
  avg_rating: number;
  overdue_count: number;
  daily_last_30_days: { date: string; count: number }[];
}

export interface AppealStatusUpdate {
  status: AppealStatus;
  comment?: string;
  deadline_days?: number;
  assignee_id?: string;
  department?: string;
}

export interface AppealMedia {
  id: number;
  url: string;
  thumbnail_url?: string;
  media_type?: string;
  created_at?: string;
}

export interface AppealStatusLogEntry {
  id: number;
  from_status?: AppealStatus;
  to_status: AppealStatus;
  comment?: string;
  changed_by_full_name?: string;
  created_at: string;
}

export interface AppealDetail extends AppealListItem {
  description?: string;
  body?: string;
  district?: string;
  user_full_name?: string;
  user_phone?: string;
  user_email?: string;
  media?: AppealMedia[];
  status_log?: AppealStatusLogEntry[];
  comments?: { id: number; body: string; created_at: string; author_full_name?: string }[];
  category?: { id: number; name_ru?: string; name_kk?: string };
  rating?: number;
  rating_comment?: string;
  deadline?: string;
}

export const appealsApi = {
  list: (params?: {
    status?: string;
    category_id?: number;
    department?: string;
    search?: string;
    date_from?: string;
    date_to?: string;
    limit?: number;
    offset?: number;
  }) => client.get<AppealListItem[]>('/api/admin/appeals/', { params }),

  get: (id: number) =>
    client.get<AppealDetail>(`/api/admin/appeals/${id}`),

  updateStatus: (id: number, data: AppealStatusUpdate) =>
    client.patch<AppealListItem>(`/api/admin/appeals/${id}/status`, data),

  stats: (params?: { date_from?: string; date_to?: string }) =>
    client.get<AppealStats>('/api/admin/appeals/stats', { params }),

  overdue: (params?: { limit?: number; offset?: number }) =>
    client.get<AppealListItem[]>('/api/admin/appeals/overdue', { params }),

  export: (params?: { status?: string; category_id?: number; date_from?: string; date_to?: string }) =>
    client.get('/api/admin/appeals/export', { params, responseType: 'blob' }),
};
